module.exports = __webpack_public_path__ + "static/media/lane-ended.132fae6e.png";